export default "__VITE_ASSET__ClmlGTtL__"